import React from "react";

const Divider = ({ className = "" }) => {
  return (
    <div className={`h-9 w-px mx-1 border-l border-gray-200 ${className}`}></div>
  );
};

export default Divider;
